// @flow
import periodItems from './periodItems';


const filterId: 'period' = 'period';
export default filterId;

export { periodItems };
